export class GaugeLevels {
  public static state(value: number): string {
    if (value < 10) { return 'krit'; }
    if (value < 33) { return 'warn'; }
    return 'ok';
  }
}
